import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthProviderType } from '../auth/auth.constants';

import { AUTH_PROVIDER } from '../auth/auth.provider';
import { IAuthProvider } from '../auth/auth-provider.interface';

import {
  clientToken,
  tokenSignal
} from '../constants/auth-state';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly authProvider =
    inject<IAuthProvider>(AUTH_PROVIDER);

  private readonly excludedUrls = [
    '/client-login',
    '/verify-otp',
    '/login',
    '/refresh-token',
    '/forgot-password',
    '/reset-password'
  ];

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (this.excludedUrls.some(x => req.url.endsWith(x))) {
      return next.handle(req);
    }

    // Preference links authenticate this pre-OTP lookup with their own token.
    if (req.url.endsWith('/get-lead-info') && req.headers.has('Authorization')) {
      return next.handle(req);
    }

    if (clientToken()) {
      return next.handle(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${clientToken()}`
          }
        })
      );
    }

    // Keycloak access tokens must always come from the provider so updateToken()
    // can refresh the token before each protected backend request.
    if (environment.auth.provider === AuthProviderType.Keycloak) {
      return this.authProvider.getAccessToken().pipe(

        switchMap(token => {

          if (!token) {
            return next.handle(req);
          }

          return next.handle(
            req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            })
          );

        })

      );
    }

    if (tokenSignal()) {
      return next.handle(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenSignal()}`
          }
        })
      );
    }

    return this.authProvider.getAccessToken().pipe(

      switchMap(token => {

        if (!token) {
          return next.handle(req);
        }

        return next.handle(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          })
        );

      })

    );

  }

}